import * as React from 'react';

import { Layer } from 'bernie-view';
import { QueryRoute } from 'bernie-core';

import { ToolbarType, UitkToolbar } from 'uitk-react-toolbar';
import { UitkDialogContent, UitkFullscreenDialog } from 'uitk-react-dialog';

export const TermsAndConditionsDialog = ({ action, routeStore }) => {
  const closeAction = () => {
    routeStore.goBack();
  };

  return (
    <QueryRoute query={{ pwaDialog: 'couponTerms' }}>
      <Layer id="coupon-terms" onDismiss={closeAction}>
        <UitkFullscreenDialog strictFullscreen={false}>
          <UitkToolbar
            header={action.actionDetails.title}
            iconLabel={action.actionDetails.accessibilityLabel}
            action={closeAction}
            type={ToolbarType.CLOSE}
          />
          <UitkDialogContent>
            <div className="all-t-padding-three uitk-unformatted-html" dangerouslySetInnerHTML={{ __html: action.actionDetails.details }} />
          </UitkDialogContent>
        </UitkFullscreenDialog>
      </Layer>
    </QueryRoute>
  );
};
